// Renderer registry. A column opts into a cell renderer by string key
// (`renderer: 'state_badge'`); entity_slot.svelte looks it up here. Renderers are
// dumb components taking { value, row, column }. Add one by dropping a component
// here and registering it. Unknown keys fall through to plain text in entity_slot.
import StateBadge from './state_badge.svelte'
import DateCell from './date.svelte'
import Avatar from './avatar.svelte'
import MediaThumb from './media_thumb.svelte'
import Boolean from './boolean.svelte'
import Tags from './tags.svelte'
import Points from './points.svelte'
import Award from './award.svelte'
import Toggle from './toggle.svelte'
import Schedule from './schedule.svelte'
import ReportSummary from './report_summary.svelte'
import MomentMedia from './moment_media.svelte'

export const RENDERERS = {
  state_badge: StateBadge,
  date: DateCell,
  avatar: Avatar,
  media_thumb: MediaThumb,
  boolean: Boolean,
  tags: Tags,
  points: Points,
  award: Award,
  toggle: Toggle,
  schedule: Schedule,
  report_summary: ReportSummary,
  moment_media: MomentMedia
}

export function rendererFor(name) {
  return name ? RENDERERS[name] ?? null : null
}
